<template>
    <div class="large-switch" :class="{ on: active }" @click.prevent="toggle">
        <div class="switch">
            <div class="label on">ON</div>
            <div class="bullet"></div>
            <div class="label off">OFF</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'LargeSwitch',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            on: true,
        }
    },
    methods: {
        toggle() {
            this.$emit('toggle', !this.active)
        },
    },
}
</script>
<style lang="sass" scoped>
.large-switch
    width: 52px
    height: 21px
    border-radius: 99em
    background: $neutral-3
    position: relative
    overflow: hidden

    &:hover
        cursor: pointer

    .switch
        height: 100%
        display: flex

        .bullet
            height: 15px
            width: 15px
            background: white
            border-radius: 99em
            position: absolute
            top: 3px
            left: 3px
            +transition(100ms)

        .label
            position: absolute
            top: 50%
            transform: translate(0, -45%)
            pointer-events: none
            +transition(100ms)
            user-select: none

            &.off
                right: 6px
                opacity: 1
                color: white

            &.on
                left: 8px
                opacity: 0

    &.on
        background: $primary-1

        .switch

            .bullet
                left: calc(100% - 15px - 3px)

            .label

                &.on
                    left: 8px
                    opacity: 1
                    color: white

                &.off
                    right: -8px
                    opacity: 0
</style>
